import { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';

export interface GetInstructorParams {
  status?: 'active' | 'inactive' | 'both';
}

export interface Instructor {
  tenant_id: string;
  user_id: string;
  calendar_color: string | null;
  created_at: string | null;
  updated_at: string | null;
  user: {
    tenant_id: string;
    id: string;
    title: string | null;
    first_name: string | null;
    middle_name: string | null;
    last_name: string | null;
    nickname: string | null;
    email: string | null;
    date_of_birth: string | null;
    sex: string | null;
    active: boolean;
    created_at: string | null;
    updated_at: string | null;
    created_by: string | null;
    updated_by: string | null;
    des_id: string | null;
  };
}

export type GetInstructorsResult = Instructor[] | null;

async function getInstructors(params: GetInstructorParams) {
  // Set the API endpoint URL
  const result = await privateApi.get<GetInstructorsResult>(`${import.meta.env.VITE_API_BASE_URL}/users/instructors`, {
    params: {
      status: params?.status ?? 'both',
    },
  });

  // return the data object
  return result.data;
}

const useGetInstructors = createQuery<GetInstructorsResult, GetInstructorParams, AxiosError<ErrorResponse>>({
  queryKey: ['instructors'],
  fetcher: (variables) => getInstructors(variables),
});

export { getInstructors, useGetInstructors };
